module.exports = __webpack_public_path__ + "static/img/cp_icon_B06.6c18e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B06.png
// module id = CFhu
// module chunks = 1